import {
  Box,
  Card,
  CardContent,
  Divider,
  IconButton,
  LinearProgress,
  Typography,
} from "@mui/material";
import FruitifyIcon from "./FruitifyIcons";
import { CheckCircle, Delete } from "@mui/icons-material";
import * as React from "react";

const formatBytes = (bytes) => {
  if (bytes === 0) return "0 B";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

export const FileCard = ({ file, handleDeleteFile = null, index = null }) => {
  if (
    (handleDeleteFile && index === null) ||
    (!handleDeleteFile && index !== null)
  ) {
    throw new Error(
      "FileCard: If handleDeleteFile is provided, index must also be provided, and vice versa.",
    );
  }
  const canDelete = handleDeleteFile && index !== null;

  return (
    <Card variant="file-card" sx={{ mb: 2 }}>
      <CardContent>
        {/* Top row: icon, filename, delete */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" alignItems="center" gap={1}>
            <FruitifyIcon name="Assignment" fontSize="large" />
            <Typography variant="subtitle1" fontWeight={600}>
              {file.name}
            </Typography>
          </Box>
          {canDelete && (
            <IconButton onClick={() => handleDeleteFile(index)}>
              <Delete />
            </IconButton>
          )}
        </Box>

        {/* Bottom row: upload status */}
        <Box mt={1}>
          <Box display="flex" alignItems="center" gap={1} mb={1}>
            <Typography variant="body2">{formatBytes(file.size)}</Typography>
            <Divider orientation="vertical" flexItem />
            <CheckCircle color="success" />
          </Box>
          <LinearProgress variant="determinate" value={100} />
        </Box>
      </CardContent>
    </Card>
  );
};
